import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";

interface BannerSettings {
  image_url: string;
  link_url: string | null;
  is_active: boolean;
}

export const Banner = () => {
  const [bannerSettings, setBannerSettings] = useState<BannerSettings | null>(null);
  const { toast } = useToast();

  useEffect(() => {
    const fetchBannerSettings = async () => {
      try {
        const { data, error } = await supabase
          .from("banners")
          .select("*")
          .eq('is_active', true)
          .order("created_at", { ascending: false })
          .limit(1)
          .maybeSingle();

        if (error) {
          console.error("Error fetching banner settings:", error);
          toast({
            title: "Erreur",
            description: "Impossible de charger les paramètres de la bannière",
            variant: "destructive",
          });
          return;
        }

        if (data) {
          setBannerSettings(data);
        }
      } catch (error) {
        console.error("Error in banner component:", error);
      }
    };

    fetchBannerSettings();
  }, [toast]);

  if (!bannerSettings?.image_url) {
    return null;
  }

  const BannerContent = () => (
    <img
      src={bannerSettings.image_url}
      alt="Banner"
      className="w-[970px] h-[250px] object-cover mx-auto mt-4"
    />
  );

  return (
    <div className="w-full flex justify-center">
      {bannerSettings.link_url ? (
        <a
          href={bannerSettings.link_url}
          target="_blank"
          rel="noopener noreferrer"
          className="block"
        >
          <BannerContent />
        </a>
      ) : (
        <BannerContent />
      )}
    </div>
  );
};
